export const BETBY_SCRIPT_URL = 'https://ui.invisiblesport.com/bt-renderer.min.js'
export const BETBY_BRAND_ID = import.meta.env.VITE_BETBY_BRAND_ID
export const BETBY_BASENAME = '/sportsbook'

export interface BTRendererInitializeOptions {
	brand_id: string
	token: string | null
	themeName?: string
	lang?: string
	target: HTMLElement
	minFrameHeight?: number
	betSlipOffsetTop?: number
	betslipZIndex?: number
	basename?: string
	url?: string
	onTokenExpired?: () => Promise<string | null>
	onRouteChange?: (...args: unknown[]) => void
	onLogin?: () => void
	onRegister?: () => void
	onSessionRefresh?: () => void
	onRecharge?: () => void
}

export interface BTRendererInstance {
	initialize: (options: BTRendererInitializeOptions) => BTRendererInstance
	updateOptions?: (options: Record<string, unknown>) => void
	kill?: () => void
}

declare global {
	interface Window {
		BTRenderer?: new () => BTRendererInstance
	}
}
